import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import TableColumnAction from "../../shared/entity/TableColumnAction";

const columns = (actions, entityName) => [
    {
        field: "id",
        name: "ID",
        sortable: true,
        render: (item) => (
            <span>
                <Link to={entityName ? `/database/${entityName}/${item}` : ""}>#{item}</Link>
            </span>
        ),
        width: 70,
    },
    {
        field: "name",
        name: <FormattedMessage id="client.name" />,
        sortable: true,
        render: (item) => <b>{item}</b>,
    },
    {
        field: "organizationType",
        name: <FormattedMessage id="client.type" />,
        sortable: true,
    },
    {
        field: "startDate",
        dataType: "date",
        name: <FormattedMessage id="client.startDate" />,
        sortable: true,
    },
    {
        field: "shouldNotify",
        name: <FormattedMessage id="client.notify" />,
        sortable: true,
    },
    {
        field: "creatorId",
        name: <FormattedMessage id="client.creator.id" />,
        sortable: false,
    },
    {
        field: "creatorEmail",
        name: <FormattedMessage id="client.creator.email" />,
        sortable: false,
    },
    {
        field: "creatorType",
        name: <FormattedMessage id="client.creator.type" />,
        sortable: false,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: TableColumnAction(actions),
    },
];

export default columns;
